module.exports = __webpack_public_path__ + "media/images/icons/rarr_yellow-72161723aa30a4471aa7c78ad3b4a855.svg";